module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("io5vl"))).then(() => parcelRequire('1iHdE'));